import ByBlogrollCreateView from "../../backyard/view/blogroll/Create.vue";
import ByBlogrollListView from "../../backyard/view/blogroll/List.vue";


let lbBlogrollRouter = [

];

let byBlogrollRouter = [
	{
		path: 'blogroll/list',
		name: "byBlogrollList",
		component: ByBlogrollListView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byBlogrollList",
					title: "友情链接列表"
				}
			]
		}
	},
	{
		path: 'blogroll/create',
		name: "byBlogrollCreate",
		component: ByBlogrollCreateView,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byBlogrollList",
					title: "友情链接列表"
				},
				{
					name: "byBlogrollCreate",
					title: "创建友情链接"
				}
			]
		}
	},
	{
		path: 'blogroll/edit/:id',
		name: "byBlogrollEdit",
		component: ByBlogrollCreateView,
		meta: {requiresAuth: true}
	}
];


export {lbBlogrollRouter, byBlogrollRouter}





// WEBPACK FOOTER //
// ./src/common/router/BlogrollRouter.js